export const TITLE_TEXT_SIZE = '1.25rem';
